import DgCardline from './src/main.vue'
// 为组件提供 install 安装方法，供按需引入
DgCardline.install = function (Vue) {
  Vue.component(DgCardline.name, DgCardline)
}
export default DgCardline

export { DgCardline }